import { FunctionComponent, SVGProps, useEffect, useRef } from "react";
import styles from "./styles.module.css";
import LoadingSpinner from "../LoadingSpinner";

interface InfoFieldProps {
  title?: string;
  subtitle?: string | null;
  IconSVG?: FunctionComponent<SVGProps<SVGSVGElement>>;
  buttonTextColour?: string;
  IconFill?: string;
  onClick?: () => void;
  buttonText: string;
  isLoading?: boolean;
}

const InfoField = ({
  title,
  subtitle,
  IconSVG,
  buttonTextColour,
  IconFill,
  buttonText,
  onClick,
  isLoading,
}: InfoFieldProps) => {
  const svgRef = useRef<SVGSVGElement>(null);
  useEffect(() => {
    if (svgRef.current && IconFill) {
      svgRef.current.setAttribute("fill", IconFill);
    }
  }, []);
  return (
    <div className={styles.infoFieldContainer}>
      <div className={styles.infoFieldIconContainer}>
        {IconSVG && <IconSVG ref={svgRef} />}
      </div>
      {isLoading ? (
        <div className={styles.loadinSpinnerContainer}>
          <LoadingSpinner />
        </div>
      ) :
        <div className={styles.infoFieldRightsideContainer}>
          <p className={styles.infoFieldTitle}>{title}</p>
          <p className={styles.infoFieldSubtitle}>{subtitle}</p>
          <p
            className={styles.infoFieldButtonText}
            onClick={onClick}
            style={{ color: buttonTextColour ? buttonTextColour : "initial" }}
          >
            {buttonText}
          </p>
        </div>
      }
    </div>
  );
};

export default InfoField;
